import { Box, Grid, Typography, Card, CardContent, Collapse, Backdrop, CircularProgress } from '@mui/material';
import {  ExpandMore, ExpandLess } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import EnhancedCertificateBadge from '../../../common/Badge/EnhancedCertificateBadge';
import './CertificateList.css';
import { useGetCertificateDataQuery } from '../../Gnn/gnnApiSlice';


const CertificateList = () => {
  const [expandedCards, setExpandedCards] = useState({});
  const [certificates, setCertificates] = useState([]);
  const [isPrimaryLoading, setIsPrimaryLoading] = useState(true);
  const {
    data: certificateData,
    isLoading: isCertificateDataLoading,
    isError: isCertificateDataError,
  } = useGetCertificateDataQuery();

  const toggleEmployeeList = (certificateId) => {
    setExpandedCards((prev) => ({
      ...prev,
      [certificateId]: !prev[certificateId],
    }));
  };

  useEffect(() => {
    if (!isCertificateDataLoading && !isCertificateDataError && certificateData) {
      setCertificates(certificateData?.data);
      setIsPrimaryLoading(false);
    } else if (isCertificateDataLoading) {
      setIsPrimaryLoading(true);
    }
  }, [certificateData, isCertificateDataError, isCertificateDataLoading]);

  return (
    <>
      <Box className="certificateListContainer">
        <Grid container spacing={3}>
          {certificates.map((cert) => (
            <Grid item xs={12} sm={6} md={4} key={cert.certificateId}>
              <Card className="certificateCard">
                <CardContent className="cardContent">
                  <Box className="certificateBadgeContainer" onClick={() => toggleEmployeeList(cert.certificateId)}>
                    <EnhancedCertificateBadge
                      certificateName={cert.certificateName}
                      size="medium"
                      badgeColor="#094ba0ff"
                    />
                  </Box>

                  <Typography className="certificateName">{cert.certificationName}</Typography>

                  <Box className="employeeListContainer">
                    <Box className="employeeListHeader" onClick={() => toggleEmployeeList(cert.certificateId)}>
                      <Typography variant="subtitle2" className="employeeCount">
                       Certified People ({cert.employees.length})
                      </Typography>
                      {expandedCards[cert.certificateId] ? <ExpandLess /> : <ExpandMore />}
                    </Box>

                    <Collapse in={expandedCards[cert.certificateId]} timeout="auto" unmountOnExit>
                      {cert.employees.length > 0 ? (
                        cert.employees.map((employee, index) => (
                          <Box key={employee.employeeId} className="employeeItem">
                            <Typography variant="body2" className="employeeName">
                              {employee.employeeName}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" className="employeeDetails">
                              {employee.deptName} • {employee.completionDate}
                            </Typography>
                          </Box>
                        ))
                      ) : (
                        <Typography variant="body2" color="text.secondary" className="noEmployeesMessage">
                          No employees certified yet
                        </Typography>
                      )}
                    </Collapse>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      {isPrimaryLoading && (
        <Backdrop
          open={true}
          style={{
            zIndex: 10000,
            color: 'white',
          }}
        >
          <CircularProgress color={'inherit'} size={'50px'} />
        </Backdrop>
      )}
    </>
  );
};

export default CertificateList;
